<div class="strength-container">
  <div class="strength-bars" [ngClass]="'strength-' + passwordScore">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
  <div class="strength-text" [ngClass]="'strength-' + passwordScore">
    @switch (passwordScore) {
      @case (-1) {
        <ng-container i18n>Zu Kurz</ng-container>
      }
      @case (0) {
        <ng-container i18n>Sehr Schwach</ng-container>
      }
      @case (1) {
        <ng-container i18n>Schwach</ng-container>
      }
      @case (2) {
        <ng-container i18n>Mittelmäßig</ng-container>
      }
      @case (3) {
        <ng-container i18n>Stark</ng-container>
      }
      @case (4) {
        <ng-container i18n>Sehr Stark</ng-container>
      }
    }
  </div>
</div>
